"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("./Button.styles"));
var _excluded = ["className", "appearance", "variant", "fullWidth", "loading", "children", "startIcon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Button = function Button(_ref) {
  var _buttonClasses;
  var className = _ref.className,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'secondary' : _ref$appearance,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$startIcon = _ref.startIcon,
    startIcon = _ref$startIcon === void 0 ? null : _ref$startIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _Button.default)();

  // STYLES
  var buttonClasses = (_buttonClasses = {
    root: (0, _classnames.default)(classes.root, className, {
      noChildren: !children
    })
  }, _defineProperty(_buttonClasses, variant, (0, _classnames.default)(classes[variant], {
    secondary: appearance === 'secondary',
    primary: appearance === 'primary',
    destructive: appearance === 'destructive',
    success: appearance === 'success',
    white: appearance === 'white',
    disabled: appearance === 'disabled'
  })), _defineProperty(_buttonClasses, "startIcon", (0, _classnames.default)(classes.startIcon, {
    noChildren: !children
  })), _defineProperty(_buttonClasses, "disabled", classes.disabled), _defineProperty(_buttonClasses, "sizeLarge", classes.sizeLarge), _defineProperty(_buttonClasses, "sizeSmall", classes.sizeSmall), _defineProperty(_buttonClasses, "outlinedSizeSmall", classes.outlinedSizeSmall), _defineProperty(_buttonClasses, "outlinedSizeLarge", classes.outlinedSizeLarge), _buttonClasses);
  var spinnerClasses = {
    root: (0, _classnames.default)(classes.circularProgress, variant, {
      secondary: appearance === 'secondary',
      primary: appearance === 'primary',
      destructive: appearance === 'destructive',
      success: appearance === 'success',
      white: appearance === 'white'
    })
  };
  var cssLoadingSpinner = (0, _classnames.default)(classes.loadingSpinner, {
    asIcon: startIcon
  });
  var cssButtonText = (0, _classnames.default)(classes.buttonText, {
    loading: loading,
    withIcon: startIcon
  });

  // RENDERS
  var loadingSpinner = /*#__PURE__*/_react.default.createElement("span", {
    className: cssLoadingSpinner
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    size: 20,
    classes: spinnerClasses
  }));
  var iconLeft = loading && startIcon ? loadingSpinner : startIcon;
  return /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    disableRipple: true,
    variant: variant,
    classes: buttonClasses,
    fullWidth: fullWidth,
    startIcon: iconLeft
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: cssButtonText
  }, children), loading && !startIcon && loadingSpinner);
};
var _default = Button;
exports.default = _default;